import { Theme } from './modules/theme/theme.service';

export type AppFeature = 'time' | 'chat' | 'sales' | 'purchase';

// controls the flat rate expense options on bookings
// never: the option is hidden
// pick: the option is visible and selectable by the user
// force: the option is hidden but always set
export enum FlatRateExpenseMode {
  Never,
  Pick,
  Force,
}

export interface TenantDef {
  id: number;
  name: string;
  theme: Theme;
  realm: string;
  customerOnCall: string;
  flatRateExpenseMode: FlatRateExpenseMode;
  lunchBreakEnabled: boolean;
  materialBookingEnabled: boolean;
  anlageEnabled: boolean;
  ownClientContributionEnabled: boolean;
  swapExternalAndInternalText: boolean;
  domainPattern: RegExp;
  domain: RegExp;
}

export type TenantConfiguration = Record<string, TenantDef>;

export function tenantForId(
  tenants: TenantConfiguration,
  id: number | string,
): TenantDef {
  return Object.values(tenants).find((t) => t.id.toString() === id.toString());
}
